/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import IdentityModel from 'cio/models/identity';
import { tracked } from '@glimmer/tracking';

interface SetupGuideChannelsEmailAddFromAddressArgs {
  identities: IdentityModel[];
  identitiesInUse: IdentityModel[];
  onAdd: () => unknown;
}

export default class SetupGuideChannelsEmailAddFromAddress extends Component<SetupGuideChannelsEmailAddFromAddressArgs> {
  @tracked isAdding = false;

  @action
  toggleAdding() {
    this.isAdding = !this.isAdding;
  }

  @action
  onSave() {
    this.isAdding = false;
    this.args.onAdd();
  }

  @action
  onDiscard() {
    this.isAdding = false;
  }
}
